export const EXPENSE_FIELD_DEFS = [
  { id: 'item', label: 'Item', description: 'What was bought' },
  { id: 'itemCategory', label: 'Item category', description: 'Food, travel, office, and so on' },
  { id: 'amount', label: 'Amount', description: 'Cost of this item' },
  { id: 'boughtPlace', label: 'Bought place', description: 'Shop or location — recorded with the entry' },
  { id: 'paymentStatus', label: 'Amount paid / Udhaar', description: 'Paid now or bought on credit' },
  { id: 'image', label: 'Bill image', description: 'Receipt or bill photo' },
];

export const DEFAULT_EXPENSE_CATEGORIES = [
  'Food',
  'Travel',
  'Office',
  'Groceries',
  'Fuel',
  'Other',
];

export const DEFAULT_EXPENSE_FIELDS = {
  item: { enabled: true, required: true },
  itemCategory: { enabled: true, required: false },
  amount: { enabled: true, required: true },
  boughtPlace: { enabled: true, required: false },
  paymentStatus: { enabled: true, required: false },
  image: { enabled: true, required: false },
};

export const DEFAULT_EXPENSE_CONFIGURATION = {
  currency: 'INR',
  whoCanAddExpenses: 'ALL',
  categories: DEFAULT_EXPENSE_CATEGORIES,
  fields: { ...DEFAULT_EXPENSE_FIELDS },
};

export const normalizeExpenseFields = (fields) => {
  const base = {};
  EXPENSE_FIELD_DEFS.forEach(({ id }) => {
    const raw = fields && typeof fields === 'object' ? fields[id] : null;
    const enabled = raw
      ? raw.enabled === true || raw.enabled === 'true' || raw.enabled === 1
      : DEFAULT_EXPENSE_FIELDS[id].enabled;
    const required = raw
      ? raw.required === true || raw.required === 'true' || raw.required === 1
      : DEFAULT_EXPENSE_FIELDS[id].required;
    base[id] = {
      enabled,
      required: enabled && required,
    };
  });
  return base;
};

export const isExpenseTrackingEvent = (eventType) =>
  String(eventType || '').toUpperCase() === 'EXPENSE_TRACKING';

export const isExpenseSharingEvent = (eventType) =>
  String(eventType || '').toUpperCase() === 'SPLITWISE';

export const expenseFieldEnabled = (fields, id) =>
  Boolean(normalizeExpenseFields(fields)[id]?.enabled);

export const expenseFieldRequired = (fields, id) =>
  Boolean(normalizeExpenseFields(fields)[id]?.required);
